import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CopilotFilters } from '../../modules/Copilot';

interface CopilotFiltersState {
  isOpen: boolean;
  isCopilotDisabled: boolean;
  industries: string[];
  functions: string[];
  impact: string[];
  benefitAreas: string[];
}

const initialState: CopilotFiltersState = {
  isOpen: false,
  isCopilotDisabled: true,
  industries: [],
  functions: [],
  impact: [],
  benefitAreas: [],
};

export const copilotSlice = createSlice({
  name: 'copilotFilters',
  initialState,
  reducers: {
    setCopilotOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setCopilotDisabled(state, action: PayloadAction<boolean>) {
      state.isCopilotDisabled = action.payload;
    },
    toggleCopilot: (state) => {
      state.isOpen = !state.isOpen;
    },
    updateCopilotFilters: (state, action: PayloadAction<Partial<CopilotFilters>>) => {
      Object.assign(state, action.payload);
    },
    resetCopilotFilters: (state) => {
      state.industries = [];
      state.functions = [];
      state.impact = [];
      state.benefitAreas = [];
    },
  },
});

export const {
  setCopilotOpen,
  setCopilotDisabled,
  toggleCopilot,
  updateCopilotFilters,
  resetCopilotFilters,
} = copilotSlice.actions;

export default copilotSlice.reducer;
